module.exports = "https://cwa.roocdn.com/_next/static/riders.6856d560.jpg";